export const ALGOLIA_SEARCH_CHANNEL = 'algolia'
